import * as React from "react";
const DesignSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.646 2.646a1.914 1.914 0 0 1 2.708 2.707L8 12.707V13a3 3 0 0 1-3 3H2v-3a3 3 0 0 1 3-3h.293l7.353-7.354ZM7.5 9.207 6.207 10.5 7.5 11.793 8.793 10.5 7.5 9.207Zm2 .586 5.146-5.147a.914.914 0 1 0-1.292-1.293L8.207 8.5 9.5 9.793ZM5 11a2 2 0 0 0-2 2v2h2a2 2 0 0 0 2-2v-.293L5.293 11H5Z" }));
DesignSmall.displayName = "DesignSmall";
var DesignSmall_default = DesignSmall;
export {
  DesignSmall_default as default
};
